import { useMemo } from 'react';
import { useRecoilState } from 'recoil';
import {
  workspaceState
} from "../../store/workspaceAtoms";

const useWorkspaceContext = () => {
  const [workspace, setWorkspace] = useRecoilState(workspaceState);

  const context = useMemo(() => ({
    workspace,
    setWorkspace,
  }), [
    workspace,
    setWorkspace,
  ]);

  return context;
};

export default useWorkspaceContext;